import { PropertyFrontendConfig, PropertyFrontendConfigWithDoor } from "../../api";
import { useContext } from "react";
import { TenantContext } from "../tenant-context";
import mergeWith from "lodash.mergewith";

/**
 * This method returns configuration that has logic to get data by priority
 * * Matches propertyId
 * * Matches origin
 * * Tenant leve config
 * @param propertyId propertyId if exists
 * @param origin bas url of the client
 */
export const usePropertyConfig = ({
  propertyId,
  origin
}: {
  propertyId?: string;
  origin?: string;
}): PropertyFrontendConfig => {
  const {
    properties,
    features,
    locale,
    theme,
    pwa,
    earliestCheckinOffset,
    allowedLocales,
    search,
    preferredCountries,
    toneOfVoice,
    disabledCountriesForIdentification,
    disabledCountriesForPassportUpload,
    themeOverride,
    secondScreenDevices,
    additionalTravelBuddyFields
  } = useContext(TenantContext);

  const propertyConfigById = propertyId ? properties?.[propertyId] : undefined;
  const propertyConfigByOrigin = properties
    ? Object.values(properties).find(
        (propertyConfig) =>
          propertyConfig.baseUrls && origin && propertyConfig.baseUrls.indexOf(origin) > -1
      )
    : undefined;

  const tenantLevel: PropertyFrontendConfig = {
    ...{
      features,
      locale,
      theme,
      pwa,
      earliestCheckinOffset,
      allowedLocales,
      search,
      preferredCountries,
      toneOfVoice,
      disabledCountriesForIdentification,
      disabledCountriesForPassportUpload,
      themeOverride,
      secondScreenDevices,
      additionalTravelBuddyFields
    }
  };

  if (!(propertyConfigById || propertyConfigByOrigin)) {
    return tenantLevel;
  }

  return mergeWith(
    tenantLevel,
    propertyConfigById?.frontend ?? propertyConfigByOrigin?.frontend,
    (objValue: PropertyFrontendConfig, srcValue: PropertyFrontendConfigWithDoor) => {
      if (Array.isArray(objValue)) {
        return srcValue;
      }
      return undefined;
    }
  );
};
